import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoginForm from '../components/Auth/LoginForm';
import { FiShield } from 'react-icons/fi';

export default function LoginPage() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-muted border-t-primary rounded-full animate-spin"></div>
      </div>
    );
  }

  if (user) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-background flex flex-col md:flex-row relative">
      
      {/* Left Branding Section */}
      <div className="hidden md:flex flex-col justify-center items-start w-1/2 p-16 lg:p-24 z-10 border-r border-border bg-muted/30">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded bg-primary flex items-center justify-center">
            <FiShield size={20} className="text-primary-foreground" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-foreground tracking-tight">Manager Admin</h1>
          </div>
        </div>
        <h2 className="text-3xl lg:text-4xl font-bold text-foreground leading-tight mb-4 tracking-tight">
          Centralized child panel infrastructure.
        </h2>
        <p className="text-muted-foreground text-lg leading-relaxed max-w-md">
          A powerful dashboard to deploy, monitor, and scale your child panels seamlessly.
        </p>
      </div>

      {/* Right Login Section */}
      <div className="flex-1 flex items-center justify-center p-6 sm:p-12 z-10">
        <div className="w-full max-w-md">
          {/* Mobile Logo */}
          <div className="md:hidden flex items-center justify-center gap-3 mb-8">
            <div className="w-10 h-10 rounded bg-primary flex items-center justify-center">
              <FiShield size={20} className="text-primary-foreground" />
            </div>
            <span className="text-xl font-bold text-foreground tracking-tight">Manager Admin</span>
          </div>

          <div className="mb-6 flex flex-col items-center md:items-start text-center md:text-left">
            <h3 className="text-2xl font-bold text-foreground tracking-tight">Welcome Back</h3>
            <p className="text-muted-foreground text-sm mt-1">Sign in to your account to continue</p>
          </div>
          
          <div className="card p-6">
            <LoginForm />
          </div>
        </div>
      </div>

    </div>
  );
}
